const menuList = [
  {
    picPath: "/static/homeIcon/home.png",
    title: "首页",
    tips: "HOME",
    code: "home",
    status: "0",
    isShow: false,
  },
  {
    picPath: "/static/homeIcon/zhongxin.png",
    title: "中心简介",
    tips: "INTRODUCTION",
    code: "zxSummary",
    status: "0",
    isShow: false,
  },
  {
    picPath: "/static/homeIcon/xinxifuwu.png",
    title: "信息服务",
    tips: "SERVICES",
    code: "xinxiServer",
    status: "0",
    isShow: false,
  },
  {
    picPath: "/static/homeIcon/ziyuan.png",
    title: "资源导航",
    tips: "RESOURCES",
    code: "zydh",
    status: "0",
    isShow: false,
  },
];

const dropDownMenu = [
  {
    path: "/index/personal",
    name: "个人中心",
    isShow: true,
  },
  {
    path: "/back",
    name: "系统管理",
    isShow: false,
  },
  {
    path: "/index",
    name: "退出",
    isShow: true,
  },
];

const loginPath = {
  path: `https://sso.scnu.edu.cn/AccountService/openapi/auth.html?client_id=${`933f5914a9887ef2cb7401e5ab2d2e15`}&response_type=${`code`}&redirect_url=${`https://ipisc.scnu.edu.cn`}`,
};

const loginOut = `https://sso.scnu.edu.cn/AccountService/user/logout.html?client_id=${`933f5914a9887ef2cb7401e5ab2d2e15`}&response_type=${`code`}&forward=${`https://ipisc.scnu.edu.cn`}`;

module.exports = {
  menuList,
  dropDownMenu,
  loginPath,
  loginOut,
};
